<template>
    <section class="club_user_create main-body">
       <h3 class="subheading">User Info</h3>
        <section class="section-container overflow-hidden">
            <div class="container__wrapper">
                <div class="middle">
                    <label
                        class="label"
                        for="email"
                    >
                        Email
                    </label>
                    <v-text-field
                        v-model="userFormFields.email"
                        placeholder="Email"
                        type="email"
                        :rules="emailRules"
                        variant="solo"
                        class="half"
                        flat
                    />
                </div>
                
            </div>
            <div class="container__wrapper">
                <div class="left">
                    <label
                        class="label"
                        for="given_name"
                    >
                        First Name
                    </label>
                  
                    <v-text-field
                        v-model="userFormFields.given_name"
                        type="text"
                        placeholder="First Name"
                        variant="solo"
                        :rules="[rules.required]"
                        flat
                    />
                </div>
                <div class="right">
                    <label
                        class="label"
                        for="family_name"
                    >
                        Last Name
                    </label>
                    <v-text-field
                        v-model="userFormFields.family_name"
                        type="text"
                        placeholder="Last Name"
                        variant="solo"
                        :rules="[rules.required]"
                        flat
                    />
                </div>
            </div>
        </section>
        <sticky-footer
            :errorMessage="errorMessage"
            :status="saveStatus"
            @buttonClicked="saveForm(userFormFields.email)"
            :allowPreview="false"
        />
    </section>
</template>

<script>
import axios from "axios"
import StickyFooter from "../../components/Library/StickyFooter";
import { validate } from "graphql";

export default {
    name: "ClubUserForm",
    components: {
        StickyFooter
    },
    data: () => ({
        errorMessage: "",
        userFormFields: {},
        visible: "",
        valid: false,
        saveError: "",
        saveStatus: "needsSaving",
        api: `${process.env.VUE_APP_CLUBSAPI}`,
        rules: {
            required: (value) => !!value || "Required."
        },
        emailRules: [
            value => !!value || "Email address is required",
            value => /.+@.+/.test(value) || "Email must be valid"
        ]
    }),
    mounted() {
        this.userFormFields = {
            given_name: null,
            family_name: null,
            email: null,
            email_verified: "false",
        }
    },
    methods: {
        saveForm(id) {
            console.log('save-id', id)
            this.saveStatus = "saving";
            this.errorMessage = "";
            this.$getCurrentUserJwToken().subscribe((jwt) => {
                axios({
                    method: "PUT",
                    url: `${this.api}/users/${id}`,
                    headers: { 
                        Authorization: jwt
                    },
                    data: {
                        data: {
                            type: "club-page-user",
                            id: id,
                            attributes: this.userFormFields  
                        }   
                    },
                })
                .then((response) => {
                    console.log(response)
                    this.saveStatus = "saved";
                    if (response.status === 200) {
                        var userData = response.data.data
                        this.$router.push({
                            path: `/clubuser/${userData.id}`
                        })
                    }
                })
                .catch((e) => {
                    console.error("Problem creating club users", e);
                    this.saveStatus = "needsSaving";
                    this.errorMessage = "Problem creating club users";
                });
            });
        },

      
        }
}
</script>

<style lang='scss'>

.club_user_create {
    .subheading {
        margin: 35px 0 20px;
        padding: 0;
        color: #67247C;
        font-size: 16px;
        font-weight: 400;
        line-height: 1;
        text-transform: capitalize;

        &__closed {
            border-bottom: 1px solid $lightgrey;
            padding-bottom: 12px;
        }
        &:hover {
            cursor: pointer;
        }

        &__label {
            position: relative;
            top: -2px;
            margin: 0 0 0 8px;
            padding: 4px 8px;
            color: #67247C;
            font-size: 12px;
            font-weight: 400;
            background-color: #E6E8F1;
            border-radius: 4px;
        }
    }

    .half {
        width: 50%;
    }

    .v-text-field {
        input {
            padding: 24px 5px;
            max-width: 100%;
            border: 1px solid #ccc;
            border-radius: 4px;
        }

        .v-input__control {
            .v-input__slot {
                &:before {
                    border-style: none;
                }
            }
        }
    }

    .container__wrapper {

        .left, .right {
            width: 50%
        }

        .right {
            padding-left: 15px;
        }
    }
}
</style>